import { AxiosResponse } from 'axios';
import { Config } from '../config';
import { LoginResponse } from '../types/authTypes';
import apiClient from './apiClient';
import { CMSCustomer } from '../types/CMSTypes';

// status = active, inactive
const getCMSCustomers = async (params: {
  status: string;
  page: number;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.get<LoginResponse>(
    Config.endPoint.getCustomers
      .replace('{status}', params.status)
      .replace('{page}', `${params.page}`)
  );
  return response;
};

const createCustomer = async (
  params: Partial<CMSCustomer>
): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.createCustomer,
    params
  );
  return response;
};

const editCustomer = async (
  params: Partial<CMSCustomer>
): Promise<AxiosResponse> => {
  const response = await apiClient.instance.patch<LoginResponse>(
    Config.endPoint.editCustomer,
    params
  );
  return response;
};

const getAllUsers = async (params: {
  page?: number;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.get<LoginResponse>(
    Config.endPoint.getUsers.replace('{page}', `${params.page}`)
  );
  return response;
};

const getAllSubscriptions = async (params: {
  page?: number;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.get<LoginResponse>(
    Config.endPoint.getSubscriptions.replace('{page}', `${params.page}`)
  );
  return response;
};

const getAllUsersByCustomer = async (params: {
  customerId: string;
  page: 1;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.get<LoginResponse>(
    Config.endPoint.getUsersByCustomerId.replace(
      '{customerID}',
      params.customerId
    )
  );
  return response;
};

const getCustomerByCustomerId = async (params: {
  customerId: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.get<LoginResponse>(
    Config.endPoint.getCustomersById.replace('{customerID}', params.customerId)
  );
  return response;
};

const attachUserToCustomer = async (params: {
  email: string;
  customerId: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.attachUserToCustomer,
    params
  );
  return response;
};

const deleteUserAccount = async (params: {
  email: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<any>(
    Config.endPoint.deleteUserAccount,
    params
  );
  return response;
};

const removeUserFromPlan = async (params: {
  userId: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.removeUserfromPlan,
    params
  );
  return response;
};

const deactivateCustomerById = async (params: {
  customerId: string;
}): Promise<AxiosResponse> => {
  const response = await apiClient.instance.post<LoginResponse>(
    Config.endPoint.deactivateCustomer,
    params
  );
  return response;
};

export const CMSService = {
  getCMSCustomers,
  createCustomer,
  editCustomer,
  getAllUsers,
  getAllSubscriptions,
  getCustomerByCustomerId,
  getAllUsersByCustomer,
  removeUserFromPlan,
  attachUserToCustomer,
  deleteUserAccount,
  deactivateCustomerById,
};
